<template>
  <div>
    <el-dialog
      title="评价编辑"
      :visible.sync="dialogFormVisible"
      width="700px"
      :close-on-click-modal="false"
      @close="emitClose"
    >
      <el-form
        :model="dataForm"
        label-position="right"
        ref="formRules"
        :rules="rules"
        label-width="100px"
        size="small"
      >
        <el-form-item
          label="添加用户："
          prop="users"
        >
          <div class="tag-wrap">
            <el-tag
              class="user-item"
              style="margin-right:16px;"
              size="medium"
              :disable-transitions="false"
              v-if="userChoose"
            >
              {{userChoose.mobile ? `${userChoose.nickname || userChoose.username}/${userChoose.mobile}` : (userChoose.nickname || userChoose.username)}}
            </el-tag>
            <el-button
              type="text"
              @click="handleUserChoose"
            >选择用户</el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="商品评价："
          prop="content"
        >
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入商品评价"
            v-model="dataForm.content"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="上传图片："
          prop="pictures"
          ref="image"
        >
          <el-upload
            :action="imgUploadUrl"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :file-list="fileList"
            :limit="3"
            accept=".png,.jpg,.jpeg"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="基础点赞量："
          prop="like_base_count"
        >
          <el-input-number v-model="dataForm.like_base_count"></el-input-number>
        </el-form-item>
        <!--     <el-form-item
          label="真实点赞量："
          prop="like_base_count"
        >
          <el-input-number v-model="dataForm.like_real_count"></el-input-number>
        </el-form-item> -->
        <el-form-item
          label="发布时间："
          prop="publish_time"
        >
          <el-date-picker
            v-model="dataForm.publish_time"
            type="datetime"
            style="width:100%"
            clearable
            value-format="timestamp"
            placeholder="请选择发布时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="排序值："
          prop="sort"
        >
          <el-input-number v-model="dataForm.sort"></el-input-number>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="emitClose">取 消</el-button>
        <el-button
          type="primary"
          @click="submit('formRules')"
        >确 定</el-button>
      </div>

    </el-dialog>
    <MemberChooseSingle
      :visible="userChooseDialog"
      @close="userChooseDialog = false"
      @submit="saveMember"
    ></MemberChooseSingle>
  </div>
</template>

<script>




import MemberChooseSingle from "@/components/dialog/member/MemberChooseSingle";
import { productappraiseUpdate, productappraiseOne } from "@/api/product";
import { imgUploadUrl, uploadHeaders } from "@/config/index";


export default {
  components: {
    MemberChooseSingle
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      dataForm: {},
      dialogFormVisible: this.isVisible,
      majorOptions: [],
      rules: {
        content: [{ required: true, message: "请输入商品评价", trigger: "blur" }],
        publish_time: [{ required: true, message: "请选择发布时间", trigger: "change" }],
        users: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!this.userChoose) {
              callback(new Error('请选择用户'))
            } else {
              callback()

            }
          },
        }],
      },
      userChooseDialog: false,
      userChoose: null,
      imgUploadUrl: imgUploadUrl(),
      fileList: [],

    };
  },
  mounted() {

  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val;
      if (val) {
        this.fetchDetail()
      }
    },

  },
  methods: {
    fetchDetail() {
      productappraiseOne({ id: this.id }).then((res) => {
        this.userChoose = res.user
        this.dataForm = res
        this.fileList = res.content_file_urls ? res.content_file_urls.split(',').map(v => {
          return {
            url: v
          }
        }) : []
      });
    },
    emitClose() {
      this.$emit("close");
    },
    handleUserChoose() {
      this.userChooseDialog = true;
    },
    saveMember(users) {
      this.userChoose = users.users
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handleSuccess(response, file, fileList) {
      this.fileList.push({
        url: response.data.url
      })
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let data = {
            id: this.id,
            uid: this.userChoose.id,
            content: this.dataForm.content,
            publish_time: this.dataForm.publish_time,
            like_base_count: this.dataForm.like_base_count,
            sort: this.dataForm.sort,
            /*     like_real_count: this.dataForm.like_real_count, */
            content_file_urls: this.fileList.length ? this.fileList.map(v => {
              return v.url
            }).join(',') : "",

          }
          productappraiseUpdate(data).then((res) => {
            this.$message.success('提交成功')
            this.$emit('submit')
            this.emitClose()
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },


  },
};
</script>

<style lang="less" scoped>
.el-input,
.el-select {
  width: 100%;
}
</style>